module.exports = __webpack_public_path__ + "f615be5c.png";